import { SText } from '@setvi/shared/components';
import { Pricing } from '@setvi/shared/interfaces';

interface PriceProps {
  value: number;
  label: Pricing['label'];
  bold: boolean;
}

export const Price = ({ value, label, bold }: PriceProps) => (
  <SText
    title={`${label}: ${
      value >= 0 && value !== null
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
    weight={bold ? 'semibold' : 'normal'}
  />
);
